import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { memo, useCallback } from 'react';
import classNames from 'classnames/bind';
import style from "./styles.pcss";
import { InitialSearchResult } from "./components/InitialSearchResult";
import { DropdownOption } from "./components/DropdownOption";
import { getIsActiveOption } from "./utils/getIsActiveOption";
import { withCalculatedPosition } from "./hocs";
var cn = classNames.bind(style);

/** выпадашка списка остается во внутреннем пользовании, пока не понадобится снаружи в каких-то кейсах */
var _DropdownList = /*#__PURE__*/memo(function (_ref) {
  var options = _ref.options,
    activeOption = _ref.activeOption,
    onOptionClicked = _ref.onOptionClicked,
    pending = _ref.pending,
    emptyText = _ref.emptyText,
    className = _ref.className,
    calculatedPosition = _ref.calculatedPosition,
    dropdownRef = _ref.dropdownRef;
  var handleClick = useCallback(function (option) {
    onOptionClicked(option);
  }, [onOptionClicked]);
  var emptyResult = !pending && !options.length && emptyText;
  return /*#__PURE__*/React.createElement("ul", {
    className: cn('list', className, _defineProperty({}, "list--".concat(calculatedPosition), !!calculatedPosition)),
    ref: dropdownRef,
    "data-t-id": "src-DropdownList"
  }, (pending || emptyResult) && /*#__PURE__*/React.createElement(InitialSearchResult, {
    emptyText: emptyText,
    pending: pending
  }), !pending && options.map(function (option) {
    return /*#__PURE__*/React.createElement("li", {
      className: cn('list__option-wrapper'),
      key: option.id
    }, /*#__PURE__*/React.createElement(DropdownOption, _extends({}, option, {
      active: getIsActiveOption({
        option: option,
        activeOption: activeOption
      }),
      onClick: handleClick,
      options: option
    })));
  }));
});
_DropdownList.displayName = _DropdownList.name;
export var DropdownList = withCalculatedPosition(_DropdownList);